// extracted by mini-css-extract-plugin
export var actionText = "_s1-4";
export var container = "_s1-0";
export var leftSection = "_s1-1";
export var rightSection = "_s1-2";
export var settingsButton = "_s1-6";
export var settingsIcon = "_s1-7";
export var shortcut = "_s1-5";
export var shortcutGroup = "_s1-3";